// noinspection DuplicatedCode

import {Grid, Typography} from "@mui/material";
import React from "react";
import BackContinueButtons from "./QuestionnaireComponents/BackContinueButtons";
import {useFormNavigation} from "../../Hooks/useFormNavigation";
import {useReduxDataHandler} from "../../Hooks/useFormDataHandler";
import {Helmet} from "react-helmet";
import {ScreeningBoxMonthYear} from "./QuestionnaireComponents/ScreeningBoxes";
import useReduxFormData from "../../Hooks/useReduxFormData";
import {fetchManifestations} from "../../Redux/manifestations/manifestationSlice";
import {useValidateToken} from "../../Hooks/useValidateToken";

const CancerScreeningsAllCont = () => {
  useValidateToken(true, "health");
  const [dispatch, usersState, , , manifestationsState, addManifestations] = useReduxFormData();
  const {
    ids: maniIds,
    manifestationsDirty,
    manifestationsDbPostLoading,
    entities,
    manifestationsFetchLoading
  } = manifestationsState;
  const {usersSelfRelationId} = usersState;

  const {handleDateColChange, handleRadioChanged} = useReduxDataHandler();
  const {handleFormNavigation} = useFormNavigation();

  const validateInputs = () => {
    return true;
  }

  return (
    manifestationsFetchLoading
      ? undefined
      : (<>
          <Helmet>
            <title>Cancer Screenings</title>
          </Helmet>
          <Grid container item xs={12} justifyContent={"center"} className="questionnaire-wrapper">
            <Grid item xs={8}>
              <Typography textAlign={"center"} variant="h2" mt={5}>&nbsp;</Typography>
            </Grid>
            <Grid item xs={12}>
              <form className={"questionnaire-content"}
                    onSubmit={async (e) => {
                      e.preventDefault()
                      if (validateInputs()) {
                        if (manifestationsDirty) {
                          await addManifestations(Object.values(entities).filter((m) => m.edited === true))
                            .unwrap()
                            .then(() => {dispatch(fetchManifestations(usersSelfRelationId))})
                            .then(() => handleFormNavigation(e));
                        }
                        handleFormNavigation(e)
                      }
                    }}>
                <Grid spacing={2} container justifyContent={"center"} ml={"auto"} mr={"auto"}
                      className="questionnaire-inner-content">
                  <Grid container item justifyContent={{sm: "center"}} flexDirection={"row"}>
                    <Grid item xs={6} md={4}>
                      <label htmlFor="doctorSkinCancerCheck">
                        Do you see a doctor to get checked for skin cancer?
                      </label>
                    </Grid>
                    <Grid item>
                      <input type="radio"
                             value={4486}
                             name={"doctorSkinCancerCheck"}
                             opp-manifestation={4487}
                             defaultChecked={maniIds.includes(4486) || maniIds.includes("4486")}
                             onChange={(e) => {
                               handleRadioChanged(e, usersSelfRelationId)
                             }}
                      /><span>&nbsp;Yes&nbsp;</span>
                      <input type="radio"
                             value={4487}
                             name={"doctorSkinCancerCheck"}
                             opp-manifestation={4486}
                             defaultChecked={maniIds.includes(4487) || maniIds.includes("4487")}
                             onChange={(e) => {
                               handleRadioChanged(e, usersSelfRelationId)
                             }}
                      /><span>&nbsp;No&nbsp;</span>
                    </Grid>
                  </Grid>
                  {
                    (maniIds.includes(4486) || maniIds.includes("4486")) &&
                    <ScreeningBoxMonthYear labelText="When was the last visit?"
                                           inputName="doctorSkinCancerCheck"
                                           manifestationsState={manifestationsState}
                                           maniId={4486}
                                           handleInputChange={handleDateColChange} />
                  }
                  <Grid container item justifyContent={{sm: "center"}} flexDirection={"row"}>
                    <Grid item xs={6} md={4}>
                      <label htmlFor="hadLungCt">
                        Have you ever had a lung CT?
                      </label>
                    </Grid>
                    <Grid item>
                      <input type="radio"
                             value={4488}
                             name={"hadLungCt"}
                             opp-manifestation={4489}
                             defaultChecked={maniIds.includes(4488) || maniIds.includes("4488")}
                             onChange={(e) => {
                               handleRadioChanged(e, usersSelfRelationId)
                             }}
                      /><span>&nbsp;Yes&nbsp;</span>
                      <input type="radio"
                             value={4489}
                             name={"hadLungCt"}
                             opp-manifestation={4488}
                             defaultChecked={maniIds.includes(4489) || maniIds.includes("4489")}
                             onChange={(e) => {
                               handleRadioChanged(e, usersSelfRelationId)
                             }}
                      /><span>&nbsp;No&nbsp;</span>
                    </Grid>
                  </Grid>
                  {
                    (maniIds.includes(4488) || maniIds.includes("4488")) &&
                    <ScreeningBoxMonthYear labelText="When was your last lung CT?"
                                           inputName="hadLungCt"
                                           manifestationsState={manifestationsState}
                                           maniId={4488}
                                           handleInputChange={handleDateColChange} />
                  }
                  <Grid container item justifyContent={{sm: "center"}} flexDirection={"row"}>
                    <Grid item xs={6} md={4}>
                      <label htmlFor="hadThyroidUltrasound">Have you ever had a thyroid ultrasound?</label>
                    </Grid>
                    <Grid item>
                      <input type="radio"
                             value={4494}
                             name={"hadThyroidUltrasound"}
                             opp-manifestation={4495}
                             defaultChecked={maniIds.includes(4494) || maniIds.includes("4494")}
                             onChange={(e) => {
                               handleRadioChanged(e, usersSelfRelationId)
                             }}
                      /><span>&nbsp;Yes&nbsp;</span>
                      <input type="radio"
                             value={4495}
                             name={"hadThyroidUltrasound"}
                             opp-manifestation={4494}
                             defaultChecked={maniIds.includes(4495) || maniIds.includes("4495")}
                             onChange={(e) => {
                               handleRadioChanged(e, usersSelfRelationId)
                             }}
                      /><span>&nbsp;No&nbsp;</span>
                    </Grid>
                  </Grid>
                  {
                    (maniIds.includes(4494) || maniIds.includes("4494")) &&
                    <ScreeningBoxMonthYear labelText="When was the last ultrasound?"
                                           inputName="hadThyroidUltrasound"
                                           manifestationsState={manifestationsState}
                                           maniId={4494}
                                           handleInputChange={handleDateColChange} />
                  }
                  <BackContinueButtons loading={manifestationsDbPostLoading} />
                </Grid>
              </form>
            </Grid>
          </Grid>
        </>
      ))
}

export default CancerScreeningsAllCont;